export default {
    url: '/interactive',
    template: '<materials-interactive/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/materials/interactive/index.js